import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {CmsEventPostLinkContainerModel } from '../../../../../../models/aggregates/cms/event-calendar';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})

export class CmsEventPostLinkService extends BaseApiPublicLoginTemplateService<CmsEventPostLinkContainerModel, CmsEventPostLinkContainerModel, CmsEventPostLinkContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-post-links/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-post-links/backoffice-ep';
        this.httpClient = http;
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-post-links/' + BaseApiTemplateService.PUBLIC_EP;
      }
}